export default __webpack_public_path__ + "static/media/image-12.2bd3677d.png";